<template>
  <div class="serviceheader">
    <h3>服务流程</h3>
    <div class="container">
      <span>业务沟通</span>
      <img src="@/assets/image/homeview/vector.png" alt="企业文化" />
      <span>项目评估</span>
      <img src="@/assets/image/homeview/vector.png" alt="企业文化" />
      <span>支付费用</span>
      <img src="@/assets/image/homeview/vector.png" alt="企业文化" />
      <span>安全审计</span>
      <img src="@/assets/image/homeview/vector.png" alt="企业文化" />
      <span>出具报告</span>
    </div>
    <p>Service Process</p>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  // background-color: skyblue;
}
@media screen and (min-width: 769px) and (max-width: 1200px) {
  // background-color: pink;
}
@media screen and (min-width: 1201px) and (max-width: 2600px) {
  .serviceheader {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    padding-top: 168px;
    h3 {
      color: var(--web-color-text-white, #fff);
      font-family: PingFang SC;
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-align: center;
    }
    .container {
      margin-top: 63px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: var(--web-color-text-white, #fff);
        font-family: PingFang SC;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      img {
        width: 40px;
        height: 27px;
        margin: 0 32px;
      }
    }
    p {
      color: var(--web-color-text-white, #fff);
      font-family: PingFang SC;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: 19.8px;
      margin-top: 200px;
      text-align: center;
    }
  }
}
</style>
